import styled from '@emotion/styled'
import { Gray400 } from '@mehilainen/mds-customer/colors'
import { MenuItem, Select } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { LanguageResult } from '../../../__generated__/api'

import Fieldset from './Fieldset'

const StyledSelect = styled(Select)`
  .MuiSelect-root {
    background-color: white;
  }
  .MuiFormHelperText-root {
    display: none;
  }
  [class*='SelectIconContainer'] {
    border-left: none;
  }
  fieldset {
    border: 1px solid ${Gray400};
  }
`

interface Props {
  languages: LanguageResult[]
  name: string
  value: LanguageResult | null
  handleChange(event: React.ChangeEvent<{ value: LanguageResult | null }>): void
  hideAccordion?: boolean
}

const LanguageSelect: React.FC<React.PropsWithChildren<Props>> = ({
  languages,
  name,
  value,
  handleChange,
}) => {
  const { t } = useTranslation()
  const options = [
    {
      value: t('common.select'),
      label: t('common.select'),
    },
    ...languages.map((language) => ({
      value: language.id.toString(),
      label: language.language,
    })),
  ]

  return (
    <Fieldset
      labelId={name}
      legend={t('component.filterOptions.languageSelect.legend')}
      expanded={value !== null}
    >
      <StyledSelect
        labelId={name}
        value={value?.id.toString() ?? t('common.select')}
        onChange={(event) => {
          const selectedId = event.target.value as unknown as string
          const selection =
            languages.find((language) => language.id.toString() === selectedId) ?? null
          handleChange({ target: { name, value: selection } } as React.ChangeEvent<{
            name: string
            value: LanguageResult | null
          }>)
        }}
        fullWidth
        placeholder={t('component.filterOptions.languageSelect.label')}
        style={{ marginBottom: 0 }}
        aria-labelledby={name}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </StyledSelect>
    </Fieldset>
  )
}

export default LanguageSelect
